(() => {
  const formatMoney = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    const hasPence = Math.round(amount * 100) % 100 !== 0;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency || 'GBP',
      minimumFractionDigits: hasPence ? 2 : 0,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const parseJson = (el) => {
    try { return JSON.parse(el?.textContent || '[]'); } catch { return []; }
  };


  function initWeddingMultiBuilder(productInfo, builder, variants, currency) {
    const root = builder.querySelector('[data-gardenia-wedding-builder]');
    if (!root) return;

    const paletteInputs = Array.from(root.querySelectorAll('[data-wedding-palette]'));
    const rows = Array.from(root.querySelectorAll('[data-wedding-item]'));
    const addButton = root.querySelector('[data-wedding-add]');
    const totalEl = root.querySelector('[data-wedding-total]');
    const countEl = root.querySelector('[data-wedding-summary-count]');
    const errorEl = root.querySelector('[data-wedding-error]');
    const mobileBar = builder.querySelector('[data-gardenia-mobile-buybar]');
    const mobileTotal = builder.querySelector('[data-gardenia-mobile-total]');
    const mobileSubmit = builder.querySelector('[data-gardenia-mobile-submit]');
    const examples = Array.from(root.querySelectorAll('[data-wedding-example]'));
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!paletteInputs.length || !rows.length || !addButton) return;

    const selectedPalette = () => paletteInputs.find((input) => input.checked)?.value || paletteInputs[0].value;

    const findVariant = (palette, arrangement) =>
      variants.find((variant) =>
        Array.isArray(variant.options) &&
        String(variant.options[0]) === String(palette) &&
        String(variant.options[1]) === String(arrangement)
      ) || null;

    const normaliseQuantity = (input) => {
      const value = Math.max(0, parseInt(input.value || '0', 10) || 0);
      input.value = String(value);
      return value;
    };

    const updateRow = (row) => {
      const palette = selectedPalette();
      const arrangement = row.dataset.weddingArrangement || '';
      const variant = findVariant(palette, arrangement);
      const input = row.querySelector('[data-wedding-qty]');
      const priceEl = row.querySelector('[data-wedding-item-price]');
      const lineTotalEl = row.querySelector('[data-wedding-line-total]');
      const image = row.querySelector('[data-wedding-item-image], .gardenia-wedding-item__image');
      const quantity = normaliseQuantity(input);
      const available = variant && variant.available !== false;

      row.dataset.weddingVariantId = variant ? String(variant.id) : '';
      row.dataset.weddingPriceCents = variant ? String(variant.price || 0) : '0';
      row.classList.toggle('is-unavailable', !available);

      if (priceEl) priceEl.textContent = variant ? formatMoney(variant.price, currency) + ' each' : 'Unavailable';
      if (lineTotalEl) lineTotalEl.textContent = variant ? formatMoney(Number(variant.price || 0) * quantity, currency) : '—';

      if (image && variant?.image) {
        if (image.tagName === 'IMG') {
          image.src = variant.image;
          image.alt = variant.alt || arrangement;
        }
      }

      row.querySelectorAll('[data-wedding-qty-minus], [data-wedding-qty-plus], [data-wedding-qty]').forEach((control) => {
        control.disabled = !available;
      });
    };

    const selectedItems = () => rows.map((row) => {
      const quantity = normaliseQuantity(row.querySelector('[data-wedding-qty]'));
      const variantId = Number(row.dataset.weddingVariantId || 0);
      const price = Number(row.dataset.weddingPriceCents || 0);
      return {
        row,
        quantity,
        variantId,
        price,
        arrangement: row.dataset.weddingArrangement || ''
      };
    }).filter((item) => item.quantity > 0 && item.variantId > 0);

    const updateExamples = () => {
      const palette = selectedPalette();
      examples.forEach((example) => {
        const quantities = String(example.dataset.recipe || '').split('|').map((value) => Math.max(0, parseInt(value || '0', 10) || 0));
        let total = 0;
        rows.forEach((row, index) => {
          const variant = findVariant(palette, row.dataset.weddingArrangement || '');
          total += Number(variant?.price || 0) * Number(quantities[index] || 0);
        });
        const totalNode = example.querySelector('[data-wedding-example-total]');
        if (totalNode) totalNode.textContent = formatMoney(total, currency);
      });
    };

    const updateTotals = () => {
      rows.forEach(updateRow);
      const items = selectedItems();
      const total = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
      const unitCount = items.reduce((sum, item) => sum + item.quantity, 0);

      if (totalEl) totalEl.textContent = formatMoney(total, currency);
      if (mobileTotal) mobileTotal.textContent = formatMoney(total, currency);

      if (countEl) {
        if (!unitCount) countEl.textContent = 'No items selected';
        else countEl.textContent = unitCount + (unitCount === 1 ? ' item selected' : ' items selected');
      }

      addButton.disabled = items.length === 0;
      addButton.textContent = items.length ? 'Add my wedding flowers to basket · ' + formatMoney(total, currency) : 'Add my wedding flowers to basket';

      if (mobileSubmit) {
        mobileSubmit.disabled = items.length === 0;
        mobileSubmit.textContent = items.length ? 'Add wedding flowers · ' + formatMoney(total, currency) : 'Add wedding flowers';
      }

      updateExamples();
    };

    const clearError = () => {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    };

    const showError = (message) => {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    };

    const setLoading = (loading) => {
      addButton.disabled = loading || selectedItems().length === 0;
      addButton.classList.toggle('loading', loading);
      if (mobileSubmit) {
        mobileSubmit.disabled = loading || selectedItems().length === 0;
        mobileSubmit.classList.toggle('loading', loading);
      }
      if (loading) {
        addButton.textContent = 'Adding your wedding flowers…';
        if (mobileSubmit) mobileSubmit.textContent = 'Adding…';
      } else {
        updateTotals();
      }
    };

    const addWeddingBasket = async () => {
      clearError();
      const selected = selectedItems();
      if (!selected.length) {
        showError('Choose at least one wedding flower item before adding to basket.');
        return;
      }

      const payload = {
        items: selected.map((item) => ({
          id: item.variantId,
          quantity: item.quantity
        }))
      };

      if (cart?.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
        payload.sections_url = window.location.pathname + window.location.search;
        cart.setActiveElement?.(document.activeElement);
      }

      setLoading(true);

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'We could not add those items to your basket.');
        }

        if (cart && data.sections) {
          const firstItem = Array.isArray(data.items) ? data.items[0] : null;
          data.id = selected[0].variantId;
          data.key = firstItem?.key || data.key;
          cart.renderContents(data);
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gardenia-wedding-builder',
            productVariantId: selected[0].variantId,
            cartData: data
          });
        }
      } catch (error) {
        showError(error.message || 'We could not add those items to your basket. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    paletteInputs.forEach((input) => {
      input.addEventListener('change', () => {
        clearError();
        updateTotals();
      });
    });

    rows.forEach((row) => {
      const input = row.querySelector('[data-wedding-qty]');
      row.querySelector('[data-wedding-qty-minus]')?.addEventListener('click', () => {
        input.value = String(Math.max(0, normaliseQuantity(input) - 1));
        clearError();
        updateTotals();
      });
      row.querySelector('[data-wedding-qty-plus]')?.addEventListener('click', () => {
        input.value = String(normaliseQuantity(input) + 1);
        clearError();
        updateTotals();
      });
      input?.addEventListener('input', () => {
        clearError();
        updateTotals();
      });
      input?.addEventListener('change', () => {
        clearError();
        updateTotals();
      });
    });

    examples.forEach((example) => {
      example.querySelector('[data-wedding-example-use]')?.addEventListener('click', () => {
        const quantities = String(example.dataset.recipe || '').split('|').map((value) => Math.max(0, parseInt(value || '0', 10) || 0));
        rows.forEach((row, index) => {
          const input = row.querySelector('[data-wedding-qty]');
          if (input) input.value = String(quantities[index] || 0);
        });
        clearError();
        updateTotals();
        root.querySelector('.gardenia-wedding-items')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    addButton.addEventListener('click', addWeddingBasket);
    mobileSubmit?.addEventListener('click', addWeddingBasket);

    const nativePicker = productInfo.querySelector('variant-selects');
    const nativeQuantity = productInfo.querySelector('[id^="Quantity-Form-"]');
    const nativeForm = productInfo.querySelector('product-form');
    const nativePrice = productInfo.querySelector('[id^="price-"]');

    [nativePicker, nativeQuantity, nativeForm, nativePrice].forEach((element) => {
      if (element) element.hidden = true;
    });

    productInfo.classList.add('gardenia-wedding-builder-active');
    if (mobileBar) document.body.classList.add('gardenia-builder-active');

    if (addButton && mobileBar && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        mobileBar.classList.toggle('is-hidden', entries[0]?.isIntersecting === true);
      }, { threshold: 0.15 });
      observer.observe(addButton);
    }

    updateTotals();
  }

  function init(productInfo) {
    const builder = productInfo.querySelector('[data-gardenia-builder]');
    if (!builder || builder.dataset.gardeniaBound === 'true') return;
    builder.dataset.gardeniaBound = 'true';

    if (builder.dataset.productAvailable === 'false') return;

    const builderMode = builder.dataset.gardeniaBuilderMode || 'standard';
    const isSubscriptionMode = builderMode === 'subscription';

    const variants = parseJson(builder.querySelector('[data-gardenia-variants]'));
    const currency = builder.dataset.currency || 'GBP';
    const picturedSize = builder.dataset.picturedSize || '';

    if (builderMode === 'wedding-multi') {
      initWeddingMultiBuilder(productInfo, builder, variants, currency);
      return;
    }
    const form = productInfo.querySelector('product-form form');
    const mainSubmit = productInfo.querySelector('product-form [type="submit"]');
    const mobileBar = builder.querySelector('[data-gardenia-mobile-buybar]');
    const mobileTotal = builder.querySelector('[data-gardenia-mobile-total]');
    const mobileSubmit = builder.querySelector('[data-gardenia-mobile-submit]');
    const cardRoot = productInfo.querySelector('[data-gardenia-card-choice]');

    if (!form) return;
    if (mobileBar) document.body.classList.add('gardenia-builder-active');

    const getSelectedVariant = () => {
      const script = productInfo.querySelector('variant-selects script[data-selected-variant]');
      try {
        const selected = JSON.parse(script?.textContent || 'null');
        if (selected) return selected;
      } catch {}

      const variantInput = form.querySelector('[name="id"]');
      const selectedId = String(variantInput?.value || '');
      return variants.find((variant) => String(variant.id) === selectedId)
        || variants.find((variant) => variant.available !== false)
        || variants[0]
        || null;
    };

    const getSelectedCard = () => cardRoot?.querySelector('[data-gardenia-card-option]:checked') || null;

    const getQuantity = () => Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1);

    const totalCents = () => {
      const variant = getSelectedVariant();
      const card = getSelectedCard();
      const collection = productInfo.querySelector('[data-gardenia-tree-collection-checkbox]:checked');
      const ceramicVase = productInfo.querySelector('[data-gardenia-vase-choice]:checked[data-vase-price-cents]');
      return (Number(variant?.price || 0) * getQuantity())
        + Number(card?.dataset.cardPriceCents || 0)
        + (Number(collection?.dataset.gardeniaTreeCollectionFeeCents || 0) * getQuantity())
        + (Number(ceramicVase?.dataset.vasePriceCents || 0) * getQuantity());
    };

    const updateStepNumbers = () => {
      const optionGroups = Array.from(
        productInfo.querySelectorAll('variant-selects fieldset.product-form__input--pill.gardenia-builder-option')
      ).filter((fieldset) => {
        const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        return inputs.length > 0 && fieldset.offsetParent !== null;
      });

      optionGroups.forEach((fieldset, index) => {
        const step = fieldset.querySelector('.gardenia-builder-step-inline');
        if (step) step.textContent = String(index + 1);
      });

      let nextStep = optionGroups.length + 1;
      const cardStep = cardRoot?.querySelector('.gardenia-step-heading__number');
      if (cardStep) {
        cardStep.textContent = String(nextStep);
        nextStep += 1;
      }

      const funeralStep = productInfo.querySelector('[data-gardenia-funeral-step]');
      if (funeralStep) {
        funeralStep.textContent = String(nextStep);
        nextStep += 1;
      }

      const giftStep = productInfo.querySelector('.gardenia-gift-fields .gardenia-step-heading__number');
      if (giftStep) giftStep.textContent = String(nextStep);
    };

    const updateCta = () => {
      const total = formatMoney(totalCents(), currency);
      if (mobileTotal) mobileTotal.textContent = total;
      if (mobileSubmit) mobileSubmit.textContent = 'Add to basket · ' + total;

      if (!isSubscriptionMode && mainSubmit && !mainSubmit.disabled && mainSubmit.getAttribute('aria-disabled') !== 'true') {
        const span = mainSubmit.querySelector('span');
        if (span) span.textContent = 'Add to basket · ' + total;
      }
    };

    const makeLabelContents = (label, name, price, note) => {
      label.textContent = '';

      const nameEl = document.createElement('span');
      nameEl.className = 'gardenia-option-name';
      nameEl.textContent = name;
      label.appendChild(nameEl);

      if (price) {
        const priceEl = document.createElement('span');
        priceEl.className = 'gardenia-option-price';
        priceEl.textContent = price;
        label.appendChild(priceEl);
      }

      if (note) {
        const noteEl = document.createElement('span');
        noteEl.className = 'gardenia-option-note';
        noteEl.textContent = note;
        label.appendChild(noteEl);
      }
    };

    const enhanceOptions = () => {
      const picker = productInfo.querySelector('variant-selects');
      if (!picker) return;

      const fieldsets = Array.from(picker.querySelectorAll('fieldset.product-form__input--pill'));
      fieldsets.forEach((fieldset) => {
        const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        if (!inputs.length) return;
        const optionName = inputs[0].dataset.optionName || '';

        fieldset.classList.add('gardenia-builder-option');

        const legend = fieldset.querySelector('legend');
        if (legend) {
          legend.textContent = '';
          const step = document.createElement('span');
          step.className = 'gardenia-builder-step-inline';

          if (/size/i.test(optionName)) {
            step.textContent = '1';
            fieldset.classList.add('gardenia-builder-option--size');
            legend.append(step, document.createTextNode('Choose your size'));
          } else if (/vase/i.test(optionName)) {
            step.textContent = '2';
            fieldset.classList.add('gardenia-builder-option--vase');
            legend.append(step, document.createTextNode('How would you like it presented?'));
          } else {
            fieldset.classList.add('gardenia-builder-option--generic');
            const optionLower = optionName.toLowerCase();
            let heading = 'Choose ' + optionName.toLowerCase();

            if (optionLower.includes('decorative bow')) heading = 'Choose a decorative bow';
            else if (optionLower === 'colour') heading = 'Choose your colour';
            else if (optionLower.includes('colour scheme')) heading = 'Choose your colour scheme';
            else if (optionLower.includes('arrangement')) heading = 'Choose your arrangement';
            else if (optionLower.includes('style')) heading = 'Choose your style';
            else if (optionLower.includes('frequency')) heading = 'Choose your frequency';
            else if (optionLower.includes('delivery')) heading = 'Choose a delivery option';
            else if (optionLower.includes('denomination')) heading = 'Choose an amount';

            step.textContent = '';
            legend.append(step, document.createTextNode(heading));

            const selectedSize = productInfo.querySelector('input[data-option-name="Size"]:checked')?.value;
            if (optionLower.includes('decorative bow') && selectedSize) {
              const noBowVariant = variants.find((variant) =>
                Array.isArray(variant.options) &&
                variant.options[0] === selectedSize &&
                /^no decorative bow$/i.test(variant.options[1] || '')
              );

              inputs.forEach((input) => {
                const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
                if (!label) return;

                const target = variants.find((variant) =>
                  Array.isArray(variant.options) &&
                  variant.options[0] === selectedSize &&
                  variant.options[1] === input.value
                );

                if (/^no decorative bow$/i.test(input.value)) {
                  makeLabelContents(label, 'No bow', 'Included', '');
                } else if (target && noBowVariant) {
                  const delta = Number(target.price) - Number(noBowVariant.price);
                  makeLabelContents(label, input.value, delta > 0 ? '+' + formatMoney(delta, currency) : '', '');
                }
              });
            }

            if (optionLower.includes('arrangement')) {
              const selectedColour = productInfo.querySelector('input[data-option-name="Colour Scheme"]:checked')?.value;
              inputs.forEach((input) => {
                const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
                if (!label) return;
                const target = variants.find((variant) =>
                  Array.isArray(variant.options) &&
                  variant.options[0] === selectedColour &&
                  variant.options[1] === input.value
                );
                makeLabelContents(label, input.value, target ? formatMoney(target.price, currency) : '', '');
              });
            }

            if (optionLower.includes('style')) {
              const baseVariant = variants.find((variant) =>
                Array.isArray(variant.options) && /no pot/i.test(variant.options[0] || '')
              ) || variants[0];

              inputs.forEach((input) => {
                const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
                if (!label) return;

                const target = variants.find((variant) =>
                  Array.isArray(variant.options) && variant.options[0] === input.value
                );

                let displayName = input.value;
                if (/no pot/i.test(input.value)) displayName = 'Plant only';
                else if (/seagrass basket/i.test(input.value)) displayName = 'With seagrass basket';
                else if (/ceramic white pot/i.test(input.value)) displayName = 'With ceramic white pot';
                else if (/black and gold stripe pot/i.test(input.value)) displayName = 'With black & gold pot';

                makeLabelContents(label, displayName, target ? formatMoney(target.price, currency) : (baseVariant ? formatMoney(baseVariant.price, currency) : ''), '');
              });
            }
          }
        }

        if (/size/i.test(optionName)) {
          const hasLongSizeLabels = inputs.some((input) => String(input.value || '').length > 20);
          fieldset.classList.toggle('gardenia-builder-option--size-wide', inputs.length > 4 || hasLongSizeLabels);

          const existingDivider = fieldset.querySelector('.gardenia-luxury-size-divider');
          if (existingDivider) existingDivider.remove();

          inputs.forEach((input) => {
            const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            if (!label) return;

            const isLuxury = /luxury/i.test(input.value);
            label.classList.toggle('gardenia-option--luxury', isLuxury);

            const baseVariant = variants.find((v) =>
              Array.isArray(v.options) &&
              v.options[0] === input.value &&
              (v.options[1] === 'No glass vase' || !v.options[1])
            ) || variants.find((v) => Array.isArray(v.options) && v.options[0] === input.value);

            const note = picturedSize && picturedSize === input.value ? 'Pictured' : '';
            makeLabelContents(label, input.value, baseVariant ? formatMoney(baseVariant.price, currency) : '', note);
          });

          const firstLuxuryInput = inputs.find((input) => /luxury/i.test(input.value));
          if (firstLuxuryInput) {
            const firstLuxuryLabel = fieldset.querySelector('label[for="' + CSS.escape(firstLuxuryInput.id) + '"]');
            if (firstLuxuryLabel) {
              const divider = document.createElement('div');
              divider.className = 'gardenia-luxury-size-divider';
              divider.innerHTML = '<span>Luxury sizes</span><small>For a fuller, more abundant arrangement</small>';
              fieldset.insertBefore(divider, firstLuxuryInput);
            }
          }
        }

        if (/vase/i.test(optionName)) {
          const selectedSize = productInfo.querySelector('input[data-option-name="Size"]:checked')?.value;
          const noVaseVariant = variants.find((v) =>
            Array.isArray(v.options) && v.options[0] === selectedSize && v.options[1] === 'No glass vase'
          );
          const vaseVariant = variants.find((v) =>
            Array.isArray(v.options) && v.options[0] === selectedSize && v.options[1] === 'Add a glass vase'
          );
          const addOn = noVaseVariant && vaseVariant ? Number(vaseVariant.price) - Number(noVaseVariant.price) : 0;

          inputs.forEach((input) => {
            const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            if (!label) return;
            if (/no glass vase/i.test(input.value)) {
              makeLabelContents(label, 'Hand-tied bouquet', 'Included', '');
            } else {
              makeLabelContents(label, 'Add a glass vase', addOn > 0 ? '+' + formatMoney(addOn, currency) : '', '');
            }
          });

          const vaseAddon = productInfo.querySelector('[data-gardenia-vase-addon]');
          if (vaseAddon) {
            const glassExtraPrice = '+' + formatMoney(Math.max(0, addOn), currency);
            const glassPriceLabel = vaseAddon.querySelector('[data-gardenia-vase-glass-price]');
            const glassChoice = vaseAddon.querySelector('[data-gardenia-vase-kind="glass"]');
            if (glassPriceLabel) glassPriceLabel.textContent = glassExtraPrice;
            if (glassChoice) glassChoice.dataset.vasePrice = glassExtraPrice;

            const ceramicPrices = Array.from(vaseAddon.querySelectorAll('[data-gardenia-vase-kind="ceramic"]'))
              .map((choice) => Number(choice.dataset.vasePriceCents || 0))
              .filter((price) => price > 0);
            const minimumPrice = Math.min(...(addOn > 0 ? [addOn] : []), ...ceramicPrices);
            if (Number.isFinite(minimumPrice)) vaseAddon.dataset.gardeniaVaseDefault = 'Optional - from ' + formatMoney(minimumPrice, currency);

            const selectedChoice = vaseAddon.querySelector('[data-gardenia-vase-choice]:checked');
            const status = vaseAddon.querySelector('[data-gardenia-vase-status]');
            if (selectedChoice && status) {
              status.textContent = selectedChoice.dataset.gardeniaVaseKind === 'none'
                ? vaseAddon.dataset.gardeniaVaseDefault
                : (selectedChoice.dataset.vaseLabel || '') + ' · ' + (selectedChoice.dataset.vasePrice || '');
            }
          }
        }
      });

      updateStepNumbers();
      updateCta();
    };

    const cardChoiceProperty = cardRoot?.querySelector('[data-gardenia-card-choice-property]');
    const cardTokenProperty = cardRoot?.querySelector('[data-gardenia-card-token-property]');
    const selectedExtra = cardRoot?.querySelector('[data-gardenia-selected-extra]');
    const selectedExtraImage = cardRoot?.querySelector('[data-gardenia-selected-extra-image]');
    const selectedExtraTitle = cardRoot?.querySelector('[data-gardenia-selected-extra-title]');
    const selectedExtraPrice = cardRoot?.querySelector('[data-gardenia-selected-extra-price]');
    const dialog = cardRoot?.querySelector('[data-gardenia-card-dialog]');
    const dialogOpen = cardRoot?.querySelector('[data-gardenia-card-dialog-open]');
    const dialogClose = cardRoot?.querySelector('[data-gardenia-card-dialog-close]');

    const syncCard = (radio) => {
      if (!radio) return;

      if (cardChoiceProperty) cardChoiceProperty.value = radio.dataset.cardLabel || '';

      const recommendedMatch = Array.from(cardRoot?.querySelectorAll('.gardenia-card-choice__grid [data-gardenia-card-option]') || [])
        .find((candidate) => candidate.value === radio.value);

      if (radio.matches('[data-card-dialog-option]') && recommendedMatch) {
        recommendedMatch.checked = true;
        radio = recommendedMatch;
      }

      if (selectedExtra) {
        const isExtra = radio.matches('[data-card-dialog-option]') && !recommendedMatch;
        selectedExtra.hidden = !isExtra;
        if (isExtra) {
          if (selectedExtraImage) {
            selectedExtraImage.src = radio.dataset.cardImage || '';
            selectedExtraImage.alt = radio.dataset.cardLabel || '';
          }
          if (selectedExtraTitle) selectedExtraTitle.textContent = radio.dataset.cardLabel || '';
          if (selectedExtraPrice) selectedExtraPrice.textContent = formatMoney(radio.dataset.cardPriceCents || 0, currency);
        }
      }

      updateCta();
    };

    cardRoot?.querySelectorAll('[data-gardenia-card-option]').forEach((radio) => {
      radio.addEventListener('change', () => {
        syncCard(radio);
        if (radio.matches('[data-card-dialog-option]') && dialog?.open) dialog.close();
      });
    });

    dialogOpen?.addEventListener('click', () => dialog?.showModal());
    dialogClose?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    syncCard(getSelectedCard());

    // Paid greeting cards are added atomically with the bouquet by product-form.js.\n\n
    mobileSubmit?.addEventListener('click', () => {
      const button = productInfo.querySelector('product-form [type="submit"]');
      button?.click();
    });

    if (mainSubmit && mobileBar && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        mobileBar.classList.toggle('is-hidden', entries[0]?.isIntersecting === true);
      }, { threshold: 0.15 });
      observer.observe(mainSubmit);
    }

    let scheduled = false;
    let mutationObserver;
    const observerOptions = { childList: true, subtree: true };

    const scheduleEnhance = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        mutationObserver?.disconnect();
        enhanceOptions();
        updateStepNumbers();
        updateCta();
        mutationObserver?.observe(productInfo, observerOptions);
      });
    };

    const quantityInput = form.querySelector('[name="quantity"]');
    quantityInput?.addEventListener('input', updateCta);
    quantityInput?.addEventListener('change', updateCta);

    productInfo.addEventListener('change', () => window.setTimeout(scheduleEnhance, 160));

    enhanceOptions();
    updateStepNumbers();
    updateCta();

    mutationObserver = new MutationObserver(scheduleEnhance);
    mutationObserver.observe(productInfo, observerOptions);
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();